import { IRequestorLA } from 'onboarding/classes/models/requestorLA'

import { TRequestorToFillLAT1Form } from '../models'

export const mapToDB = ({
  AdditionalComments,
  BuyerType,
  Exhibits,
  HPContractAdminLocation,
  PartnerTerritoryISO,
  SpecialPrograms,
}: TRequestorToFillLAT1Form): Partial<IRequestorLA> => ({
  AdditionalComments,
  BuyerType,
  Exhibits,
  HPContractAdminLocation,
  PartnerTerritoryISO: PartnerTerritoryISO.length ? PartnerTerritoryISO.join(',') : '',
  SpecialPrograms: SpecialPrograms.length ? SpecialPrograms.join(',') : '',
})
